<div class="gap-xl flex w-full flex-col items-center justify-center pt-20">
  <bx-file-upload
    acceptedFileTypes=".csv"
    [inputAriaLabel]="'elsImport.aria.fileUpload' | translate"
    [content]="contentInfo"
    [multiple]="true"
    [uploadStatus]="fileUploadStatus()"
    (fileChanged)="onFileChanged($event)"
  >
    <ng-template #contentInfo>
      <div class="text-text-tertiary-600 flex flex-col items-center text-sm">
        <p><span class="text-button-tertiary-color-fg">Click to upload</span> or drag and drop</p>
        <p>CSV</p>
        <p>{{ 'elsImport.maxFileSize' | translate: { limit: maxFileSizeMb } }}</p>
      </div>
    </ng-template>
  </bx-file-upload>

  @if (filesToUpload(); as files) {
    <button bx-button iconTrailing="upload-03" (click)="importFiles(files)" [disabled]="uploadDisabled()">
      {{ 'elsImport.upload' | translate }}
    </button>
  }

  @if (errorKey(); as errorKey) {
    <p class="text-error-700 text-sm font-medium">{{ errorKey | translate: { limit: maxFileSizeMb } }}</p>
    @if (errorMessage(); as errorMessage) {
      <p class="text-error-700 text-sm font-medium">{{ errorMessage }}</p>
    }
  }
</div>
